export default "__VITE_ASSET__krnjt7xns6YRIarnte1sfw__"